/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { TabMenu } from 'primereact/tabmenu';
import { InputTextarea } from 'primereact/inputtextarea';

import { LANGUAGE_DEFAULT } from '@constants/general';

class EditCountryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      activeTabIndex: 0,
      justification: '',
      clave: '',
      errors: []
    }
    this.initialValuesForm = {
      name: ''
    };
  }

  componentDidMount() {
    const {
      keysLenguages,
      data
    } = this.props;
      keysLenguages.map((item) =>
      this.setState({ [item]: { 
        ...this.initialValuesForm,
        name: data.nombre[item] || ''
      } })
    );
    this.setState({ clave: data.clave, loadingPage: false});
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onContinueAction, keysLenguages, onHidden, data } = this.props
    const { justification, clave } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    const name = keysLenguages.reduce((accum, item) => {
      if (this.state[item].name) accum[item] = this.state[item].name;
      return accum;
    }, {});
    onContinueAction({id: data.id, name, justification, clave})
    return onHidden()
  }

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t } = this.props
    const { justification, clave } = this.state
    const { name } = this.state[LANGUAGE_DEFAULT]
    let errors = {}
    if (!name) errors = {...errors, [`${LANGUAGE_DEFAULT}-name`]: `${t('Nombre')} ${t('es requerido')}`}
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`}
    if (!clave) errors = { ...errors, 'clave': `${t('Clave para la carga de usuarios')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  render () {
    const { t, onHidden, keysLenguages, itemsTabsLenguages } = this.props
    const { activeTabIndex, clave, errors, loadingPage } = this.state
    
    const isFormFieldValid = (name) =>
    !!(errors[name]);
  
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
        <>
          <div className="p-col-12 p-field">
            <label className="p-text-bold">{t('Nombre', {lng: prefixLenguage })}</label>
            <InputText
              name={`${prefixLenguage}-name`}
              value={this.state[prefixLenguage]?.name}
              onChange={this.onChange}
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-name`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-name`)}
          </div>
        </>
      );
    };

    const children = (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>

        <div className="p-col-12 p-field ">
          <label className="p-text-bold">{t('Clave para la carga de usuarios')}</label>
          <InputText
            name="clave"
            value={clave}
            onChange={(e) =>
            this.setState({ clave: e.target.value }, this.validateFieldsOnchange('clave', e.target.value))
          }
            className={classNames({
              'p-invalid': isFormFieldValid(`clave`),
            })}
          />
          {getFormErrorMessage(`clave`)}
        </div>
        <div className="p-col-12">
          {itemsTabsLenguages && (
            <TabMenu
              model={itemsTabsLenguages}
              activeIndex={activeTabIndex}
              onTabChange={(e) =>
                this.setState({ activeTabIndex: e.index })
              }
            />
          )}
        </div>
        {renderByTabLenguage()}
        <div className="p-col">
          <label className="p-text-bold">{t('Justificación del cambio')}</label>
        </div>
        <InputTextarea
          name="justification"
          onChange={(e) =>
            this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
          }
          rows={5}
          cols={30}
          className={classNames({
            'p-invalid': isFormFieldValid(`justification`),
          })}
        />
        {getFormErrorMessage(`justification`)}
        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button> 
            <button className="p-button p-component" type="submit">
              <span className="p-button-label p-c">Guardar</span>
            </button>
          </div>
        </div>
      </form>
    )

    if (loadingPage) return true;
    return (
      <Dialog
        header={t('Editar País')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '50vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
});

export default compose(withTranslation(), connect(mapStateToProps, null))(EditCountryModal)